/**
 * 导入工具类
 */
import { isAndroid, isHarmonyOs, isIOS } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeCallback, BridgeResponseCallback, WebViewBridge } from '../../types';

/**
 * 初始化webview bidge
 * @param callback
 */
const setupWebViewJavascriptBridge = (callback: BridgeCallback): void => {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }

  /**
   * 安卓系统或者鸿蒙系统
   */
  if (isAndroid() || isHarmonyOs()) {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      () => {
        callback(window.WebViewJavascriptBridge);
      },
      false,
    );
  }

  /**
   * iOS系统
   */
  if (isIOS()) {
    if (window.WVJBCallbacks) {
      window.WVJBCallbacks.push(callback);
    } else {
      window.WVJBCallbacks = [callback];
    }
    const WVJBIframe: HTMLIFrameElement = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__?t=' + new Date().getTime();
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 100);
  }
};

/**
 * 触发handler
 * @param name
 * @param data
 * @param callback
 */
const bridgeCallHandler = (name: string, data: string, callback: BridgeResponseCallback | null): void => {
  setupWebViewJavascriptBridge((bridge: WebViewBridge) => {
    bridge.callHandler(name, data, (res: string) => {
      if (callback) {
        callback(res);
      }
    });
  });
};

/**
 * 注册handler
 * @param name
 * @param data
 * @param callback
 */
const bridgeRegisterHandler = (name: string, data: string, callback: BridgeResponseCallback | null): void => {
  setupWebViewJavascriptBridge((bridge: WebViewBridge) => {
    bridge.registerHandler(name, (res: string, responseCallback: BridgeResponseCallback) => {
      if (callback) {
        callback(res);
      }
      responseCallback(data);
    });
  });
};

/**
 * 导出初始化方法
 */
export { setupWebViewJavascriptBridge, bridgeCallHandler, bridgeRegisterHandler };
